
import {
	Component,
	Inject,
	OnInit,
	AfterViewInit,
	Input,
} from "@angular/core";
import { IColunasGrid, IMatrizRiscoControle, IMatrizRiscoControleTeste, IMatrizRiscoControleTestesQuestao, IQuadroAuxiliar } from "../../model/matriz-risco-controle.model";
import { QuadroAuxiliarService } from "../../service/quadro-auxiliar.service";
import { BaseListComponent } from "src/app/shared/components/base-list/base-list.component";
import { QuestaoService } from "src/app/services/questao.service";
import { IQuestaoModel } from "src/app/models/questao.model";
@Component({
	selector: "app-mr-aba-testes",
	templateUrl: "./mr-aba-testes.component.html",
	styleUrls: ["./mr-aba-testes.component.scss"],
})
export class MrAbaTestesComponent extends BaseListComponent implements OnInit, AfterViewInit {
	@Input() objPrincipal!: IMatrizRiscoControle;
	@Input() visualizar: boolean;

	associadoSelecionado!: number;
	txtPrioridade!: string;
	txtTipoTeste!: string;
	txtRiscoVinculado: string = '';
	realizarTestes: boolean | null = null;
	txtJustificativa: string = '';
	readonly MENSAGEM_SEM_TESTE = 'Não serão realizados testes/Não incluído no escopo da auditoria.';



	listQuestoesGeral!: any[];
	listQuestoes!: IMatrizRiscoControleTestesQuestao[];
	listQuestoesRemover!: IMatrizRiscoControleTestesQuestao[];
	questaoSelecionada!: number;

	objEditar!: IMatrizRiscoControleTeste;

	listQuadroAuxiliar!: IQuadroAuxiliar[];
	quadroSelecionado!: IQuadroAuxiliar;

	dataSource!: any;
	listColunas: IColunasGrid[] = [
		{ id: "posicao", label: "Ref" },
		{ id: "prioridade", label: "Prioridade" },
		{ id: "tipoTeste", label: "Tipo do Teste" },
		{ id: "descricaoQuestoes", label: "Questão" },
		{ id: "descricaoRiscoVinculado", label: "Riscos" },
		{ id: "descricaoControle", label: "Controle Associado" },
	];

	constructor(private quadroAuxiliarService: QuadroAuxiliarService,
		private questoesService: QuestaoService
	) {
		super();
	}

	ngOnInit(): void {
		this.listQuestoesRemover = [];
	}

	ngAfterViewInit() {
		this.carregaQuadro();
	}

	carregaQuestoes() {
		this.questoesService.obterPorPlanejamento(this.objPrincipal.idPlanejamento, this.objPrincipal.idUnidade).then((res) => {
			if (res.dados) {
				this.listQuestoesGeral = res.dados as IQuestaoModel[];
			}
		})
			.catch((err) => {
				this.exibirMensagemErro(err.mensagem.descricao);
			});
	}

	carregaQuadro() {
		this.quadroAuxiliarService
			.obter()
			.then((res) => {
				if (res.dados) {
					this.listQuadroAuxiliar = res.dados as IQuadroAuxiliar[];
				}
			})
			.catch((err) => {
				this.exibirMensagemErro(err.mensagem.descricao);
			});
	}

	setAssociado() {
		if (this.associadoSelecionado == undefined && this.associadoSelecionado == 0) {
			this.associadoSelecionado = this.objPrincipal.associados[0].controle;
		}
	}

	changeControle() {
		this.quadroSelecionado = null;
		this.txtPrioridade = "";
		this.txtTipoTeste = "";

		let objAssociado = this.objPrincipal.associados.find(f => f.controle == this.associadoSelecionado);
		let objRisco = this.objPrincipal.riscos.find(f => f.posicao == objAssociado.controleRiscoControleRiscos);
		this.txtRiscoVinculado = objRisco ? `R${objRisco.posicao} - ${objRisco.descricaoRisco}` : '';

		this.quadroSelecionado = this.listQuadroAuxiliar.find(f => f.riscoInerente.includes(objRisco.nivelRI)
			&& f.riscoResidual.includes(objAssociado.nivelRR)
			&& f.avaliacao.includes(objAssociado.descricaoControle));
		if (this.quadroSelecionado != null && this.quadroSelecionado != undefined) {
			this.txtPrioridade = this.quadroSelecionado.prioridade;
			this.txtTipoTeste = this.quadroSelecionado.tipoTeste;
		}
		else {
			this.exibirMensagemAlerta("Não foi possível encontrar as informações no Quadro Auxiliar!");
		}
	}
	changeRealizarTestes() {
		if (this.realizarTestes === false) {
			this.marcarQuestoesParaRemocao(this.listQuestoes);
			this.listQuestoes = [];
			this.questaoSelecionada = 0;
		} else if (this.realizarTestes === true) {
			this.txtJustificativa = '';
		}
	}

	/** Questões já persistidas (id > 0) devem ir em questoesRemover ao desistir do teste. */
	private marcarQuestoesParaRemocao(questoes: IMatrizRiscoControleTestesQuestao[] | null | undefined): void {
		if (!questoes || questoes.length === 0) return;
		if (this.listQuestoesRemover == null) this.listQuestoesRemover = [];

		for (const questao of questoes) {
			if (!questao || !(questao.id > 0)) continue;
			const jaMarcada = this.listQuestoesRemover.some(q => q && q.id === questao.id);
			if (!jaMarcada) this.listQuestoesRemover.push(questao);
		}
	}

	addQuestao() {
		if (this.questaoSelecionada == 0) {
			this.exibirMensagemAlerta("Informe a questão!");
			return;
		}

		if (this.listQuestoes == null)
			this.listQuestoes = [];

		const questaoEncontrada = this.listQuestoesGeral.find(f => f.id == this.questaoSelecionada);

		const novo: IMatrizRiscoControleTestesQuestao = {} as IMatrizRiscoControleTestesQuestao;
		novo.idQuestaoPlanejamento = this.questaoSelecionada;
		novo.descricaoQuestao = `${questaoEncontrada.ordem} - ${questaoEncontrada.nome}`; // ← já inclui o número
		novo.controle = this.listQuestoes.length + 1;
		this.listQuestoes.push(novo);
	}

	removeQuestao(item: any) {
		if (item.id > 0) {
			this.listQuestoesRemover.push(this.listQuestoes.find(f => f.id === item.id));
			this.listQuestoes = this.listQuestoes.filter(f => f.id != item.id);
		}
		else
			this.listQuestoes = this.listQuestoes.filter(f => f.controle != item.controle);
	}

	remover(obj: IMatrizRiscoControleTeste) {
		if (obj.id > 0) {
			if (this.objPrincipal.testesRemover == undefined)
				this.objPrincipal.testesRemover = [];

			this.objPrincipal.testesRemover.push(this.objPrincipal.testes.find(f => f.id === obj.id));
			this.objPrincipal.testes = this.objPrincipal.testes.filter(f => f.id !== obj.id);
		}
		else
			this.objPrincipal.testes = this.objPrincipal.testes.filter(f => f.posicao !== obj.posicao);

		this.objPrincipal.testes = [...this.objPrincipal.testes];
	}


	private montarDescricaoQuestoes(): string {
		if (this.realizarTestes === false) return '-';
		if (!this.listQuestoes || this.listQuestoes.length === 0) return '-';
		return this.listQuestoes.map(q => q.descricaoQuestao).join('; ');
	}
	adicionar(): any {
		//Quando tentar adicionar e tiver apenas 1 atividade, não setava o valorselecionado
		if (this.objPrincipal.associados.length == 1) {
			this.associadoSelecionado = this.objPrincipal.associados[0].controle;
		}

		if (this.associadoSelecionado == 0 || this.associadoSelecionado == undefined) {
			this.exibirMensagemAlerta("Selecione o Controle Associado");
			return "Selecione o Controle Associado";
		}

		if (this.quadroSelecionado == null) {
			this.exibirMensagemAlerta("Não foi possível encontrar as informações no Quadro Auxiliar!");
			return "Não foi possível encontrar as informações no Quadro Auxiliar!";
		}

		if (this.realizarTestes === null || this.realizarTestes === undefined) {
			this.exibirMensagemAlerta("Informe se serão realizados testes!");
			return "Informe se serão realizados testes!";
		}

		if (this.realizarTestes === true && (this.listQuestoes == null || this.listQuestoes.length === 0)) {
			this.exibirMensagemAlerta("Associe ao menos uma Questão de auditoria!");
			return "Associe ao menos uma Questão de auditoria!";
		}

		if (this.realizarTestes === false && (!this.txtJustificativa || this.txtJustificativa.trim() === '')) {
			this.exibirMensagemAlerta("Informe a Justificativa!");
			return "Informe a Justificativa!";
		}

		if (this.objPrincipal.testes == null)
			this.objPrincipal.testes = [];

		const descricaoQuestoesComputada = this.montarDescricaoQuestoes();

		if (this.objPrincipal.testes == null)
			this.objPrincipal.testes = [];

		// Defesa: ao marcar "Não", garante remoção das questões persistidas mesmo se o change não rodou.
		if (this.realizarTestes === false) {
			this.marcarQuestoesParaRemocao(this.listQuestoes);
			if (this.objEditar?.questoes?.length) {
				this.marcarQuestoesParaRemocao(this.objEditar.questoes);
			}
			this.listQuestoes = [];
		}

		const questoesSalvar = this.realizarTestes === false ? [] : [...(this.listQuestoes || [])];
		const questoesRemoverSalvar = [...(this.listQuestoesRemover || [])];

		if (this.objEditar == null) {
			const nova: IMatrizRiscoControleTeste = {} as IMatrizRiscoControleTeste;
			nova.id = 0;
			nova.controleAssociado = this.associadoSelecionado;
			nova.questoes = questoesSalvar;
			nova.questoesRemover = questoesRemoverSalvar;
			nova.idQuadroAuxiliar = this.quadroSelecionado.id;
			nova.prioridade = this.txtPrioridade;
			nova.tipoTeste = this.txtTipoTeste;
			nova.descricaoControle = this.objPrincipal.associados.find(f => f.controle == this.associadoSelecionado).descricao;
			nova.posicao = this.objPrincipal.testes.length + 1;

			nova.realizarTestes = this.realizarTestes;
			nova.justificativa = this.realizarTestes === false ? this.txtJustificativa : '';
			nova.descricaoRiscoVinculado = this.txtRiscoVinculado;
			nova.descricaoQuestoes = descricaoQuestoesComputada;
			this.objPrincipal.testes.push(nova);
		}
		else {
			this.objEditar.controleAssociado = this.associadoSelecionado;
			this.objEditar.questoes = questoesSalvar;
			this.objEditar.questoesRemover = questoesRemoverSalvar;
			this.objEditar.idQuadroAuxiliar = this.quadroSelecionado.id;
			this.objEditar.prioridade = this.txtPrioridade;
			this.objEditar.tipoTeste = this.txtTipoTeste;

			this.objEditar.realizarTestes = this.realizarTestes;
			this.objEditar.justificativa = this.realizarTestes === false ? this.txtJustificativa : '';
			this.objEditar.descricaoRiscoVinculado = this.txtRiscoVinculado;
			this.objEditar.descricaoQuestoes = descricaoQuestoesComputada;
			this.objEditar.descricaoControle = this.objPrincipal.associados.find(f => f.controle == this.associadoSelecionado).descricao;
		}
		this.objPrincipal.testes = [...this.objPrincipal.testes];
		this.limpar();

		return this.objPrincipal.testes;
	}

	importar(id: number): any {
		if (this.objPrincipal.associados.length == 1) {
			this.associadoSelecionado = this.objPrincipal.associados[0].controle;
		}

		if (this.associadoSelecionado == 0 || this.associadoSelecionado == undefined) {
			this.exibirMensagemAlerta("Selecione o Controle Associado");
			return "Selecione o Controle Associado";
		}

		if (this.quadroSelecionado == null) {
			this.exibirMensagemAlerta("Não foi possível encontrar as informações no Quadro Auxiliar!");
			return "Não foi possível encontrar as informações no Quadro Auxiliar!";
		}

		if (this.objPrincipal.testes == null)
			this.objPrincipal.testes = [];

		const nova: IMatrizRiscoControleTeste = {} as IMatrizRiscoControleTeste;
		nova.id = 0;
		nova.controleAssociado = this.associadoSelecionado;
		nova.questoes = [...this.listQuestoes];
		nova.questoesRemover = [...this.listQuestoesRemover];
		nova.idQuadroAuxiliar = this.quadroSelecionado.id;
		nova.prioridade = this.txtPrioridade;
		nova.tipoTeste = this.txtTipoTeste;
		nova.descricaoControle = this.objPrincipal.associados.find(f => f.controle == this.associadoSelecionado).descricao;
		nova.posicao = id;
		nova.realizarTestes = true;
		nova.justificativa = '';
		nova.descricaoRiscoVinculado = this.txtRiscoVinculado;
		nova.descricaoQuestoes = this.montarDescricaoQuestoes();
		this.objPrincipal.testes.push(nova);

		this.objPrincipal.testes = [...this.objPrincipal.testes];
		this.limpar();

		return this.objPrincipal.testes;
	}

	limpar() {
		this.objEditar = null;

		this.associadoSelecionado = 0;
		this.listQuestoes = [];
		this.listQuestoesRemover = [];
		this.quadroSelecionado = null;

		this.txtRiscoVinculado = "";
		this.realizarTestes = null;
		this.txtJustificativa = "";

		this.txtPrioridade = "";
		this.txtTipoTeste = "";
	}

	editar(obj: IMatrizRiscoControleTeste) {
		this.objEditar = obj;

		this.associadoSelecionado = obj.controleAssociado;
		this.changeControle();
		this.listQuestoes = obj.questoes;
		for (let i = 0; i < this.listQuestoes.length; i++) {
			const element = this.listQuestoes[i];
			const questaoEncontrada = this.listQuestoesGeral.find(f => f.id == element.idQuestaoPlanejamento);
			element.descricaoQuestao = `${questaoEncontrada.ordem} - ${questaoEncontrada.nome}`; // ← ajustado
		}
		this.listQuestoesRemover = [];

		this.realizarTestes = obj.realizarTestes;
		this.txtJustificativa = obj.justificativa || '';
	}

	novo() {
		this.limpar();
	}

	getNameBtn() {
		if (this.objEditar == null)
			return "Adicionar";
		else
			return "Salvar";
	}
}
